(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["lumika-product"]) return;
  try {
    
  document.querySelectorAll('[data-lm-root]').forEach((root) => {
    const currency = root.dataset.currency || 'MXN';
    const money = new Intl.NumberFormat('es-MX', { style: 'currency', currency, minimumFractionDigits: 0, maximumFractionDigits: 2 });
    const promo = root.dataset.promo === 'true';
    const unit = Number(root.dataset.unit || 0);
    const totals = { 1: Number(root.dataset.t1), 2: Number(root.dataset.t2), 3: Number(root.dataset.t3) };
    const qtyInput = root.querySelector('[data-lm-qty-input]');
    const qtyOut = root.querySelector('[data-lm-qty-out]');
    const buyPrice = root.querySelector('[data-lm-buy-price]');
    const stickyPrice = root.querySelector('[data-lm-sticky-price]');
    const buyBtn = root.querySelector('[data-lm-buy]');
    const errorBox = root.querySelector('[data-lm-error]');
    const sticky = root.querySelector('[data-lm-sticky]');
    let qty = 1;

    const render = () => {
      if (!qtyInput) return;
      qtyInput.value = String(qty);
      if (qtyOut) qtyOut.textContent = String(qty);
      const total = promo && totals[qty] ? totals[qty] : unit * qty;
      const label = money.format(total / 100);
      if (buyPrice) buyPrice.textContent = label;
      if (stickyPrice) stickyPrice.textContent = label;
      root.querySelectorAll('.lm-tier').forEach((tier) => {
        tier.classList.toggle('is-selected', Number(tier.dataset.qty) === qty);
      });
    };
    root.querySelector('[data-lm-minus]')?.addEventListener('click', () => { qty = Math.max(1, qty - 1); render(); });
    root.querySelector('[data-lm-plus]')?.addEventListener('click', () => { qty = Math.min(10, qty + 1); render(); });
    root.querySelectorAll('.lm-tier input').forEach((input) => {
      input.addEventListener('change', () => { qty = Number(input.value); render(); });
    });

    root.querySelectorAll('[data-lm-thumb]').forEach((thumb) => {
      thumb.addEventListener('click', () => {
        const main = root.querySelector('[data-lm-main]');
        if (!main) return;
        main.src = thumb.dataset.src;
        main.alt = thumb.dataset.alt || '';
        root.querySelectorAll('[data-lm-thumb]').forEach((t) => t.classList.toggle('is-active', t === thumb));
      });
    });

    // Mobile sticky bar: visible only while the main purchase box is off screen.
    const anchor = root.querySelector('#comprar');
    if (anchor && sticky && 'IntersectionObserver' in window) {
      new IntersectionObserver(([entry]) => {
        const show = !entry.isIntersecting;
        sticky.classList.toggle('is-visible', show);
        sticky.setAttribute('aria-hidden', String(!show));
      }).observe(anchor);
    }

    buyBtn?.addEventListener('click', async () => {
      const form = buyBtn.closest('form');
      const variantId = Number(form.querySelector('[name="id"]').value);
      const label = buyBtn.querySelector('[data-lm-buy-label]');
      const original = label.textContent;
      errorBox.hidden = true;
      buyBtn.disabled = true;
      label.textContent = 'Abriendo pago seguro…';
      try {
        const response = await fetch(`${window.Shopify.routes.root}cart/add.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: variantId, quantity: qty }] })
        });
        if (!response.ok) throw new Error('No pudimos agregar el producto. Intenta de nuevo.');
        window.location.assign(`${window.Shopify.routes.root}checkout`);
      } catch (error) {
        errorBox.textContent = error.message || 'No pudimos abrir el pago. Intenta de nuevo.';
        errorBox.hidden = false;
        buyBtn.disabled = false;
        label.textContent = original;
      }
    });

    // Countdown tied to the real end date of the launch offer.
    const countdown = root.querySelector('[data-lm-countdown]');
    if (countdown) {
      const end = new Date(countdown.dataset.end).getTime();
      const tick = () => {
        const left = end - Date.now();
        if (left <= 0) { window.location.reload(); return; }
        const d = Math.floor(left / 86400000);
        const h = Math.floor((left % 86400000) / 3600000);
        const m = Math.floor((left % 3600000) / 60000);
        const sec = Math.floor((left % 60000) / 1000);
        const vals = { d, h, m, s: sec };
        countdown.querySelectorAll('[data-u]').forEach((el) => {
          el.textContent = String(vals[el.dataset.u]).padStart(2, '0');
        });
      };
      tick();
      setInterval(tick, 1000);
    }

    // Estimated delivery window in business days, from the visitor's own clock.
    const delivery = root.querySelector('[data-lm-delivery]');
    if (delivery) {
      const addBusinessDays = (start, days) => {
        const date = new Date(start);
        let added = 0;
        while (added < days) {
          date.setDate(date.getDate() + 1);
          if (date.getDay() !== 0 && date.getDay() !== 6) added += 1;
        }
        return date;
      };
      const fmt = new Intl.DateTimeFormat('es-MX', { weekday: 'short', day: 'numeric', month: 'short' });
      const now = new Date();
      delivery.innerHTML = `Pídela hoy y llega entre el <b>${fmt.format(addBusinessDays(now, 3))}</b> y el <b>${fmt.format(addBusinessDays(now, 7))}</b> (estimado).`;
    }

    render();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pureease-product"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-pe-root]').forEach((root) => {
    const money = new Intl.NumberFormat('es-MX', { style: 'currency', currency: 'MXN', maximumFractionDigits: 0 });
    const quantityInput = root.querySelector('[data-pe-quantity-input]');
    const quantityOutput = root.querySelector('[data-pe-quantity-output]');
    const buttonPrice = root.querySelector('[data-pe-button-price]');
    const buyButton = root.querySelector('[data-pe-buy-now]');
    const errorBox = root.querySelector('[data-pe-error]');
    const promoPrice = Number(root.dataset.promoPrice || 0);
    let quantity = 1;

    const renderQuantity = () => {
      quantityInput.value = String(quantity);
      quantityOutput.textContent = String(quantity);
      buttonPrice.textContent = money.format((promoPrice * quantity) / 100);
    };

    root.querySelector('[data-pe-quantity-minus]')?.addEventListener('click', () => {
      quantity = Math.max(1, quantity - 1);
      renderQuantity();
    });

    root.querySelector('[data-pe-quantity-plus]')?.addEventListener('click', () => {
      quantity = Math.min(10, quantity + 1);
      renderQuantity();
    });

    root.querySelectorAll('[data-pe-thumbnail]').forEach((thumb) => {
      thumb.addEventListener('click', () => {
        const main = root.querySelector('.pe-gallery__image');
        if (!main) return;
        main.src = thumb.dataset.src;
        main.removeAttribute('srcset');
        main.alt = thumb.dataset.alt || '';
        root.querySelectorAll('[data-pe-thumbnail]').forEach((item) => {
          const active = item === thumb;
          item.classList.toggle('is-active', active);
          item.setAttribute('aria-pressed', String(active));
        });
      });
    });

    buyButton?.addEventListener('click', async () => {
      const form = buyButton.closest('form');
      const variantId = Number(form.querySelector('[name="id"]').value);
      const label = buyButton.querySelector('[data-pe-buy-label]');
      const originalLabel = label.textContent;
      errorBox.hidden = true;
      buyButton.disabled = true;
      label.textContent = root.dataset.openingLabel;
      try {
        const response = await fetch(`${window.Shopify.routes.root}cart/add.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: variantId, quantity }] })
        });
        if (!response.ok) throw new Error(root.dataset.addError);
        window.location.assign(`${window.Shopify.routes.root}checkout`);
      } catch (error) {
        errorBox.textContent = error.message || root.dataset.checkoutError;
        errorBox.hidden = false;
        buyButton.disabled = false;
        label.textContent = originalLabel;
      }
    });

    renderQuantity();
  });

  } catch(e) { console.error(e); }
})();
})();
